webpackJsonp([22],{

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);








var ColumnHeader = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ColumnHeader, _React$PureComponent);

  function ColumnHeader() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleClick = function () {
      _this.props.onClick();
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ColumnHeader.prototype.render = function render() {
    var _props = this.props,
        icon = _props.icon,
        type = _props.type,
        active = _props.active,
        columnHeaderId = _props.columnHeaderId;

    var iconElement = '';

    if (icon) {
      iconElement = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-' + icon + ' column-header__icon'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('h1', {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('column-header', { active: active }),
      id: columnHeaderId || null
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      onClick: this.handleClick
    }, void 0, iconElement, type));
  };

  return ColumnHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Column; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__column_header__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scroll__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__is_mobile__ = __webpack_require__(35);











var Column = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _React$PureComponent);

  function Column() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleHeaderClick = function () {
      var scrollable = _this.node.querySelector('.scrollable');

      if (!scrollable) {
        return;
      }

      _this._interruptScrollAnimation = Object(__WEBPACK_IMPORTED_MODULE_7__scroll__["b" /* scrollTop */])(scrollable);
    }, _this.handleScroll = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function () {
      if (typeof _this._interruptScrollAnimation !== 'undefined') {
        _this._interruptScrollAnimation();
      }
    }, 200), _this.setRef = function (c) {
      _this.node = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Column.prototype.scrollTop = function scrollTop() {
    var scrollable = this.node.querySelector('.scrollable');

    if (!scrollable) {
      return;
    }

    this._interruptScrollAnimation = Object(__WEBPACK_IMPORTED_MODULE_7__scroll__["b" /* scrollTop */])(scrollable);
  };

  Column.prototype.render = function render() {
    var _props = this.props,
        heading = _props.heading,
        icon = _props.icon,
        children = _props.children,
        active = _props.active,
        hideHeadingOnMobile = _props.hideHeadingOnMobile;


    var showHeading = heading && (!hideHeadingOnMobile || hideHeadingOnMobile && !Object(__WEBPACK_IMPORTED_MODULE_8__is_mobile__["b" /* isMobile */])(window.innerWidth));

    var columnHeaderId = showHeading && heading.replace(/ /g, '-');
    var header = showHeading && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__column_header__["a" /* default */], {
      icon: icon,
      active: active,
      type: heading,
      onClick: this.handleHeaderClick,
      columnHeaderId: columnHeaderId
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      {
        ref: this.setRef,
        role: 'region',
        'aria-labelledby': columnHeaderId,
        className: 'column',
        onScroll: this.handleScroll
      },
      header,
      children
    );
  };

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent);



/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GettingStarted; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_components_column__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_components_column_subheading__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__initial_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_immutable__);





var _dec, _class, _class2, _temp;














var messages = Object(__WEBPACK_IMPORTED_MODULE_8_react_intl__["f" /* defineMessages */])({
  heading: {
    'id': 'getting_started.heading',
    'defaultMessage': 'Getting started'
  },
  home_timeline: {
    'id': 'tabs_bar.home',
    'defaultMessage': 'Home'
  },
  notifications: {
    'id': 'tabs_bar.notifications',
    'defaultMessage': 'Notifications'
  },
  public_timeline: {
    'id': 'navigation_bar.public_timeline',
    'defaultMessage': 'Federated timeline'
  },
  navigation_subheading: {
    'id': 'column_subheading.navigation',
    'defaultMessage': 'Navigation'
  },
  settings_subheading: {
    'id': 'column_subheading.settings',
    'defaultMessage': 'Settings'
  },
  community_timeline: {
    'id': 'navigation_bar.community_timeline',
    'defaultMessage': 'Local timeline'
  },
  preferences: {
    'id': 'navigation_bar.preferences',
    'defaultMessage': 'Preferences'
  },
  follow_requests: {
    'id': 'navigation_bar.follow_requests',
    'defaultMessage': 'Follow requests'
  },
  sign_out: {
    'id': 'navigation_bar.logout',
    'defaultMessage': 'Logout'
  },
  favourites: {
    'id': 'navigation_bar.favourites',
    'defaultMessage': 'Favourites'
  },
  blocks: {
    'id': 'navigation_bar.blocks',
    'defaultMessage': 'Blocked users'
  },
  keyboard_shortcuts: {
    'id': 'navigation_bar.keyboard_shortcuts',
    'defaultMessage': 'Keyboard shortcuts'
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    myAccount: state.getIn(['accounts', __WEBPACK_IMPORTED_MODULE_13__initial_state__["g" /* me */]]),
    columns: state.getIn(['settings', 'columns']),
    unreadFollowRequests: state.getIn(['user_lists', 'follow_requests', 'items'], Object(__WEBPACK_IMPORTED_MODULE_15_immutable__["List"])()).size,
    unreadNotifications: state.getIn(['notifications', 'unread'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchFollowRequests: function fetchFollowRequests() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_accounts__["v" /* fetchFollowRequests */])());
    }
  };
};

var badgeDisplay = function badgeDisplay(number, limit) {
  if (number === 0) {
    return undefined;
  } else if (limit && number >= limit) {
    return limit + '+';
  } else {
    return number;
  }
};

var GettingStarted = (_dec = Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps, mapDispatchToProps), _dec(_class = Object(__WEBPACK_IMPORTED_MODULE_8_react_intl__["g" /* injectIntl */])(_class = (_temp = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GettingStarted, _ImmutablePureCompone);

  function GettingStarted() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GettingStarted);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  GettingStarted.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        myAccount = _props.myAccount,
        fetchFollowRequests = _props.fetchFollowRequests;


    if (myAccount.get('locked')) {
      fetchFollowRequests();
    }
  };

  GettingStarted.prototype.render = function render() {
    var _props2 = this.props,
        intl = _props2.intl,
        myAccount = _props2.myAccount,
        columns = _props2.columns,
        multiColumn = _props2.multiColumn,
        unreadFollowRequests = _props2.unreadFollowRequests,
        unreadNotifications = _props2.unreadNotifications;


    var navItems = [];

    if (multiColumn) {
      if (!columns.find(function (item) {
        return item.get('id') === 'HOME';
      })) {
        navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
          icon: 'home',
          text: intl.formatMessage(messages.home_timeline),
          to: '/timelines/home'
        }, '0'));
      }

      if (!columns.find(function (item) {
        return item.get('id') === 'NOTIFICATIONS';
      })) {
        navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
          icon: 'bell',
          text: intl.formatMessage(messages.notifications),
          badge: badgeDisplay(unreadNotifications),
          to: '/notifications'
        }, '1'));
      }

      if (!columns.find(function (item) {
        return item.get('id') === 'COMMUNITY';
      })) {
        navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
          icon: 'users',
          text: intl.formatMessage(messages.community_timeline),
          to: '/timelines/public/local'
        }, '2'));
      }

      if (!columns.find(function (item) {
        return item.get('id') === 'PUBLIC';
      })) {
        navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
          icon: 'globe',
          text: intl.formatMessage(messages.public_timeline),
          to: '/timelines/public'
        }, '3'));
      }
    }

    navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
      icon: 'star',
      text: intl.formatMessage(messages.favourites),
      to: '/favourites'
    }, '4'));

    if (myAccount.get('locked')) {
      navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
        icon: 'users',
        text: intl.formatMessage(messages.follow_requests),
        badge: badgeDisplay(unreadFollowRequests, 40),
        to: '/follow_requests'
      }, '6'));
    }

    if (multiColumn) {
      navItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
        icon: 'question',
        text: intl.formatMessage(messages.keyboard_shortcuts),
        to: '/keyboard-shortcuts'
      }, '7'));
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5__ui_components_column__["a" /* default */], {
      icon: 'asterisk',
      heading: intl.formatMessage(messages.heading),
      hideHeadingOnMobile: true
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'getting-started__wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__ui_components_column_subheading__["a" /* default */], {
      text: intl.formatMessage(messages.navigation_subheading)
    }), navItems, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__ui_components_column_subheading__["a" /* default */], {
      text: intl.formatMessage(messages.settings_subheading)
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
      icon: 'ban',
      text: intl.formatMessage(messages.blocks),
      to: '/blocks'
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
      icon: 'cog',
      text: intl.formatMessage(messages.preferences),
      href: '/user-settings'
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__ui_components_column_link__["a" /* default */], {
      icon: 'sign-out',
      text: intl.formatMessage(messages.sign_out),
      href: '/auth/sign_out',
      method: 'delete'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'static-content getting-started'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('p', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: 'https://github.com/tootsuite/documentation/blob/master/Using-Mastodon/FAQ.md',
      rel: 'noopener',
      target: '_blank'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_intl__["b" /* FormattedMessage */], {
      id: 'getting_started.faq',
      defaultMessage: 'FAQ'
    })), ' \u2022 ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: 'https://github.com/tootsuite/documentation/blob/master/Using-Mastodon/User-guide.md',
      rel: 'noopener',
      target: '_blank'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_intl__["b" /* FormattedMessage */], {
      id: 'getting_started.userguide',
      defaultMessage: 'User Guide'
    })), ' \u2022 ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: 'https://github.com/tootsuite/documentation/blob/master/Using-Mastodon/Apps.md',
      rel: 'noopener',
      target: '_blank'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_intl__["b" /* FormattedMessage */], {
      id: 'getting_started.appsshort',
      defaultMessage: 'Apps'
    })), ' \u2022 ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: 'https://git.pleroma.social/pleroma/pleroma'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_intl__["b" /* FormattedMessage */], {
      id: 'getting_started.pleroma',
      defaultMessage: 'Pleroma'
    })))));
  };

  return GettingStarted;
}(__WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component___default.a), _class2.propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired,
  myAccount: __WEBPACK_IMPORTED_MODULE_11_react_immutable_proptypes___default.a.map.isRequired,
  columns: __WEBPACK_IMPORTED_MODULE_11_react_immutable_proptypes___default.a.list,
  multiColumn: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  fetchFollowRequests: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  unreadFollowRequests: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  unreadNotifications: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number
}, _temp)) || _class) || _class);


/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(44);





var ColumnLink = function ColumnLink(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      to = _ref.to,
      href = _ref.href,
      method = _ref.method,
      badge = _ref.badge;

  var badgeElement = typeof badge !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
    className: 'column-link__badge'
  }, void 0, badge) : null;

  if (href) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: href,
      className: 'column-link',
      'data-method': method
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-' + icon + ' column-link__icon'
    }), text, badgeElement);
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */], {
      to: to,
      className: 'column-link'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-' + icon + ' column-link__icon'
    }), text, badgeElement);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ColumnLink);

/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var ColumnSubheading = function ColumnSubheading(_ref) {
  var text = _ref.text;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
    className: 'column-subheading'
  }, void 0, text);
};

/* harmony default export */ __webpack_exports__["a"] = (ColumnSubheading);

/***/ })

});


// WEBPACK FOOTER //
// features/getting_started.js